import z, { nativeEnum, number, object, preprocess, string } from 'zod';

import { ScanDataFundingSource } from '@occc/graphql';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { withIsEnabled } from '../utils/with-is-enabled';

const ScanDataConfigurationEnabledSchema = object({
  fundingSource: preprocess(
    (val) => (val === '' ? undefined : val),
    nativeEnum(ScanDataFundingSource, { required_error: IS_REQUIRED }),
  ),
  description: string({ required_error: IS_REQUIRED }).min(1, IS_REQUIRED),
  discountAllocation: preprocess(
    (val) => (typeof val === 'string' && val.trim() !== '' ? parseFloat(val) : val),
    number({ required_error: IS_REQUIRED, invalid_type_error: IS_REQUIRED }).finite().min(0),
  ),
});

const ScanDataConfigurationDisabledSchema = object({
  fundingSource: z.union([nativeEnum(ScanDataFundingSource), z.literal('')]).optional(),
  description: string().optional(),
  discountAllocation: preprocess(
    (val) => (typeof val === 'string' && val.trim() !== '' ? parseFloat(val) : val),
    number().finite().min(0).optional(),
  ),
});

export const ScanDataConfigurationSchema = withIsEnabled(
  ScanDataConfigurationEnabledSchema,
  ScanDataConfigurationDisabledSchema,
);

export type ScanDataConfigurationFormValues = z.infer<typeof ScanDataConfigurationSchema>;
